import React, { ReactWithChildren, useContext } from 'react'
import * as OC from '../../data-comp'
import { OrderItem } from '../../model-order'

import Icon from 'react-fa'
import { useEditOrderSvc } from '../service'

import { StackCtx } from 'views/order/v5/comp-factory'

export function HItems(props: ReactWithChildren<{ items: OrderItem[] }>): JSX.Element {
  // const editOrderSvc = useEditOrderSvc()
  // const items = editOrderSvc.getCartItems()

  const HItem = (props: ReactWithChildren<{ item: OrderItem }>): JSX.Element => {
    console.log("HItem", props.item, props.item.id)
    return (
      <>
        <StackCtx.Provider value={props.item}>
          <OC.ItemsCtx.Provider value={props.item}>
            {props.children}
            {props.item.adjustments &&
              props.item.adjustments
                .filter((ci: OrderItem) => ci.price >= 0)
                .map((ci: OrderItem) => (
                  <StackCtx.Provider value={ci} key={ci.id}>
                    <OC.ItemsCtx.Provider value={ci}>
                      <HItem item={ci}>
                        {props.children}
                      </HItem>
                    </OC.ItemsCtx.Provider>
                  </StackCtx.Provider>
                ))}
          </OC.ItemsCtx.Provider>
        </StackCtx.Provider>
      </>
    )
  }

  return (
    <>
      {props.items.map((i: OrderItem) => (
        <HItem key={i.id} item={i}>
          {props.children}
        </HItem>
      ))}
    </>
  )
}
